<div
  style="width: 100%"
  fxLayout="row"
  class="tab-sheet"
  fxLayoutAlign="start stretch">
  <div
    fxLayout="row"
    fxLayoutAlign="stretch center"
    class="tab-container">
    @if (marginStyle) {
      <div
        class="tab-fill"
        [ngStyle]="marginStyle">
        &nbsp;
      </div>
    }
    @if (center) {
      <div
        class="tab-fill"
        fxFlex="grow">
        &nbsp;
      </div>
    }
    @for (tab of tabs; track tab; let i = $index) {
      <div
        class="tab"
        [class]="tabCssClass"
        [ngClass]="{ 'is-active': i === selectedTabIndex, 'is-disabled': isDisabled(i) }"
        (click)="tabClick(i)"
        style="white-space: nowrap">
        <i class="icon {{ getIcon(i) }}"></i>
        {{ tab }}
        @if (isCautionShown && (tab === getTabSmsType() || tab === getTabMsgType())) {
          <div class="caution-icon"></div>
        }
        @let badge = getBadge(i);
        @if (!!badge) {
          <div class="tab-badge"
            [style.background-color]="badge?.backgroundColor"
            [style.color]="badge?.color">
            {{ badge.value }}
          </div>
        }
      </div>
    }
    @if (fillSpace) {
      <div
        class="tab-fill"
        fxFlex="grow">
        &nbsp;
      </div>
    }
  </div>
</div>
